import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var externalBalanceEntities = function externalBalanceEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byBrokerIdAndCurrencyIdAndInvestmentItemIdAndUserId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_CARTVIEWBYUSERIDANDOPERATIONSTATEID_SUCCESS:
      var byBrokerIdAndCurrencyIdAndInvestmentItemIdAndUserId = action.response.byBrokerIdAndCurrencyIdAndInvestmentItemIdAndUserId;
      return merge({}, state, {
        byBrokerIdAndCurrencyIdAndInvestmentItemIdAndUserId: byBrokerIdAndCurrencyIdAndInvestmentItemIdAndUserId
      });
    default:
      return state;
  }
};
export default externalBalanceEntities;